import '@unocss/reset/tailwind.css'
import 'virtual:uno.css'
import '@/assets/global.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import GlobalComponents from '@/components'
import GlobalDirectives from '@/directives'
import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(GlobalComponents)
app.use(GlobalDirectives)

app.mount('#app')
